import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/'
import Departamento from './views/Departamento.vue'
import Vendedor from './views/Vendedor.vue'
import TipoPago from './views/TipPago.vue'
import Ventas from './views/Ventas.vue'
import Proveedor from './views/Proveedor.vue'
import Compra from './views/Compra.vue'
import Login from './views/Login.vue'
import Banco from './views/Banco.vue'
import Registrar from './views/Registrar.vue'
import Cliente from './views/Cliente.vue'
import agregar from './views/RegConPermisos.vue'
import EmpresaSeleccionada from './views/EmpresaSeleccionada.vue'
import Almacen from './views/Almacen.vue'
import Soporte from './views/Soporte.vue'
import Producto from './views/Producto.vue'
import Empresa from './views/Empresa.vue'
import Portafolio from './views/Portafolio.vue'
import Ruta from './views/Ruta.vue'
import Zona from './views/Zona.vue'
import Menu from './views/Menu.vue'
import OrdenCompra from './views/OrdenCompra.vue'
import Fabricante from './views/Fabricante.vue'
import Pedidos from './views/Pedidos.vue'
import Empleado from './views/Empleado.vue'
import FacturaPedido from './views/FacturaPedido.vue'
import Estado from './views/Estado.vue'
import Municipio from './views/Municipio.vue'
import Parroquia from './views/Parroquia.vue'
import Despacho from './views/Despacho.vue'
import TipoCliente from './views/TipoCliente.vue'
import Vehiculo from './views/Vehiculo.vue'
import Linea from './views/Linea.vue'
import Marca from './views/Marca.vue'
import Home from './views/Home.vue'
import Cuentas from './views/Cuentas.vue'
import TipoEmpleado from './views/TipoEmpleado.vue'
import Kardex from './views/Kardex.vue'
import Ajuste from './views/Ajuste.vue'
import AjustePrecio from './views/AjustePrecio.vue'
import CuentaXCobrar from './views/CuentaXCobrar.vue'
import CuentaXPagar from './views/CuentaXPagar.vue'
import CheckOrdenCompra from './views/checkOrdenCompra.vue'
import Concepto from './views/Concepto.vue'
import Perfil from './views/Perfil.vue'
import VentaCancelada from './views/VentaCancelada.vue'
import TransferirAlmacen from './views/TransferirAlmacen.vue'
import Pago from './views/Pago.vue'
import Pagocxp from './views/Pagocxp.vue'
import Configuracion from './views/Configuracion.vue'
import NotaCredito from './views/NotaCredito.vue'
import NotaDebito from './views/NotaDebito.vue'
import OrdenxCotizar from './views/OrdenxCotizar.vue'
import OrdenesDeCotizacion from './views/OrdenesDeCotizacion.vue'
import ListadoProducto from './views/ListadoProducto.vue'
import Propiedades from './views/Propiedades.vue'
import CuentaPorCobrarReporte from './views/reportes/CuentaXCobrarR.vue'
import AnalisisVencimiento from './views/reportes/AnalisisVencimientoR.vue'
import LibroVentas from './views/reportes/LibroVentas.vue'
import ReporteGerencia from './views/reportes/ReporteGerencia.vue'
import NotaEntrega from './views/NotaEntrega.vue'
import LiquidacionDespacho from './views/LiquidacionDespacho.vue'
import LiquidacionAlmacen from './views/LiquidacionAlmacen.vue'
import Serial from './views/Serial.vue'
import UnidadVenta from './views/UnidadVenta.vue'
import PresentacionProd from './views/PresentacionProd.vue'
import ConsultaPro from './views/ConsultaPro.vue'
import POS from './views/POS.vue'
import PlanificacionPromotor from './views/PlanificacionPromotor.vue'
import EjecucionEstrategica from './views/EjecucionEstrategica.vue'
import EjecucionPlanificacion from './views/EjecucionPlanificacion.vue'
import Importacion from './views/Importacion.vue'
import ImportacionOrdPendientes from './views/ImportacionOrdPendientes.vue'
import ValorInventario from './views/ValorInventario.vue'
import Consignado from './views/Consignado.vue'
import Naviera from './views/Naviera.vue'
import PaisesImportacion from './views/PaisesImportacion.vue'
import ImportacionTarifa from './views/ImportacionTarifa.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/planificacion',
      name: 'PlanificacionPromotor',
      component: PlanificacionPromotor,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/pos',
      name: 'pos',
      component: POS,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ejecucionEstrategica',
      name: 'EjecucionEstrategica',
      component: EjecucionEstrategica,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/importacion',
      name: 'Importacion',
      component: Importacion,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/importacionOrdPendientes',
      name: 'ImportacionOrdPendientes',
      component: ImportacionOrdPendientes,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/importacionTarifa',
      name: 'ImportacionTarifa',
      component: ImportacionTarifa,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/consignado',
      name: 'Consignado',
      component: Consignado,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/naviera',
      name: 'Naviera',
      component: Naviera,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/paisesImportacion',
      name: 'PaisesImportacion',
      component: PaisesImportacion,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ejecucionPlanificacion',
      name: 'EjecucionPlanificacion',
      component: EjecucionPlanificacion,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/unidadVenta',
      name: 'UnidadVenta',
      component: UnidadVenta,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/presentacionProd',
      name: 'PresentacionProd',
      component: PresentacionProd,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/consultaPro',
      name: 'ConsultaPro',
      component: ConsultaPro,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/CheckOrdenCompra',
      name: 'CheckOrdenCompra',
      component: CheckOrdenCompra,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/OrdenxCotizar',
      name: 'OrdenxCotizar',
      component: OrdenxCotizar,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/OrdenesDeCotizacion',
      name: 'OrdenesDeCotizacion',
      component: OrdenesDeCotizacion,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/transferirAlmacen',
      name: 'TransferirAlmacen',
      component: TransferirAlmacen,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/valorInventario',
      name: 'ValorInventario',
      component: ValorInventario,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/configuracion',
      name: 'Configuracion',
      component: Configuracion,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/LiquidacionDespacho',
      name: 'LiquidacionDespacho',
      component: LiquidacionDespacho,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/LiquidacionAlmacen',
      name: 'LiquidacionAlmacen',
      component: LiquidacionAlmacen,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/propiedades',
      name: 'Propiedades',
      component: Propiedades,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/kardex',
      name: 'Kardex',
      component: Kardex,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/listadoproducto',
      name: 'ListadoProducto',
      component: ListadoProducto,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ajuste',
      name: 'Ajuste',
      component: Ajuste,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ajustePrecio',
      name: 'AjustePrecio',
      component: AjustePrecio,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/departamento',
      name: 'Departamento',
      component: Departamento,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: Perfil,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/notaEntrega',
      name: 'NotaEntrega',
      component: NotaEntrega,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/Soporte',
      name: 'Soporte',
      component: Soporte,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/tipoEmpleado',
      name: 'TipoEmpleado',
      component: TipoEmpleado,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/cuentas',
      name: 'Cuenta',
      component: Cuentas,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/marca',
      name: 'Marca',
      component: Marca,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/linea',
      name: 'Linea',
      component: Linea,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/vehiculo',
      name: 'Vehiculo',
      component: Vehiculo,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/tipoCliente',
      name: 'TipoCliente',
      component: TipoCliente,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/parroquia',
      name: 'Parroquia',
      component: Parroquia,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/municipio',
      name: 'Municipio',
      component: Municipio,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/estado',
      name: 'Estado',
      component: Estado,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/portafolio',
      name: 'Portafolio',
      component: Portafolio,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/empleado',
      name: 'Empleado',
      component: Empleado,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ruta',
      name: 'Ruta',
      component: Ruta,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/zona',
      name: 'Zona',
      component: Zona,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/venta',
      name: 'Venta',
      component: Ventas,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/compra',
      name: 'Compra',
      component: Compra,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/vendedor',
      name: 'Vendedor',
      component: Vendedor,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/proveedor',
      name: 'Proveedor',
      component: Proveedor,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/empresaSeleccionada',
      name: 'EmpresaSeleccionada',
      component: EmpresaSeleccionada,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/cliente',
      name: 'Cliente',
      component: Cliente,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/banco',
      name: 'Banco',
      component: Banco,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/registrar',
      name: 'Registrar',
      component: Registrar,
      meta: {
        isPublic: true
      }
    },
    {
      path: '/usuario',
      name: 'Usuario',
      component: agregar,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/almacen',
      name: 'Almacen',
      component: Almacen,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/producto',
      name: 'Producto',
      component: Producto,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/empresa',
      name: 'Empresa',
      component: Empresa,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ordenCompra',
      name: 'OrdenCompra',
      component: OrdenCompra,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/fabricante',
      name: 'Fabricante',
      component: Fabricante,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/pedidos',
      name: 'Pedido',
      component: Pedidos,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/facturaPedido',
      name: 'FacturaPedido',
      component: function () {
        if (store.state.config && store.state.config.pedido.valor === false) {
          return import('./views/FacturaPedido.vue')
        } else if (store.state.config && store.state.config.pedido.valor === true) {
          return import('./views/FacturaMin.vue')
        }
      },
      meta: {
        isPublic: false
      }
    },
    {
      path: '/despacho',
      name: 'Despacho',
      component: Despacho,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/cuentaPorCobrar',
      name: 'CuentaPorCobrar',
      component: CuentaXCobrar,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/cuentaPorPagar',
      name: 'CuentaPorPagar',
      component: CuentaXPagar,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/concepto',
      name: 'Concepto',
      component: Concepto,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/tipopago',
      name: 'TipoPago',
      component: TipoPago,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/pago',
      name: 'Pago',
      component: Pago,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/pagocxp',
      name: 'Pagocxp',
      component: Pagocxp,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/ventaCancelada',
      name: 'VentaCancelada',
      component: VentaCancelada,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/notaDebito',
      name: 'NotaDebito',
      component: NotaDebito,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/notaCredito',
      name: 'NotaCredito',
      component: NotaCredito,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/cuentaPorCobrarR',
      name: 'CuentaPorCobrarReporte',
      component: CuentaPorCobrarReporte,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/analisisVencimientoR',
      name: 'AnalisisVencimiento',
      component: AnalisisVencimiento,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/libroVentas',
      name: 'LibroVentas',
      component: LibroVentas,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/reporteGerencia',
      name: 'ReporteGerencia',
      component: ReporteGerencia,
      meta: {
        isPublic: false
      }
    },
    {
      path: '/serial',
      name: 'Serial',
      component: Serial,
      meta: {
        isPublic: false
      }
    },
    { path: '*',
      redirect: '/Login'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isPublic)) {
    // entre al login y al registrar si no se esta logeado
    if (router.app.$cookies.get('log')) {
      // si estoy logeado entra de una vez al sistema
      next({
        path: '/home',
        query: { redirect: to.Path }
      })
    } else {
      // si no estoy logeado solo entrara al login y al registrar
      // console.log("ruta publica")
      next()
    }
  } else if (!to.matched.some(record => record.meta.isPublic)) {
    // console.log("ruta privada")
    // si la ruta no es publica
    if (!router.app.$cookies.get('log')) {
      // si no estoy logeado
      // console.log("no estas logeado")
      if (router.app.$cookies.get('token')) {
        // si no estoy logeado y tengo token
        // console.log("tienes token")
        if (to.path === '/EmpresaSeleccionada') {
          // se voy a seleccionar empresa
          next()
        } else {
          // si voy a acceder al menu redirecciona
          next({
            path: '/EmpresaSeleccionada',
            query: { redirect: to.Path }
          })
        }
      } else {
        // si no estoy logeado y no tengo token
        // console.log("no tienes token")
        next({
          path: '/',
          query: { redirect: to.Path }
        })
      }
    } else {
      // console.log("estas loegado")
      // si estoy logeado
      next()
    }
  }
})

export default router
